import React, { createContext, useContext, useState, useMemo } from 'react';

const ProviderContext = createContext(null);
export const useProvider = () => useContext(ProviderContext);

import { defaultProvider as envDefaultProvider } from '@/config/runtimeConfig';

/** defaultProvider defaults to the runtime-configured provider. */
export const ProviderProvider = ({ defaultProvider = envDefaultProvider, children }) => {
  const [provider, setProvider] = useState(defaultProvider);
  const value = useMemo(() => ({ provider, setProvider }), [provider]);
  return <ProviderContext.Provider value={value}>{children}</ProviderContext.Provider>;
};
